export const FAQS = [
  { q: 'Is this serious?',
    a: 'Yes. And also no. We are an actual five-stack of dads playing Mobile Legends competitively. We have schedules, coaches, and a Discord. We also have toddlers, so the seriousness is on a sliding scale.' },
  { q: 'Why dads only?',
    a: "Because we needed a roster that doesn't ghost when a snack is requested, knows the importance of nap-time, and treats 'Pause' as a sacred ritual. Also because being a dad and a Mythic player should not be mutually exclusive." },
  { q: "Can I try out if I don't have kids yet?",
    a: "Yes — if you're cool with being benched the moment any of us has a Tuesday-night sleep regression. We call this the 'shadow roster.' One on the way also qualifies." },
  { q: 'What if my wife says no?',
    a: "Then your wife says no. Mandatory respect. We've all been there. You may submit a deferred application." },
  { q: 'Will there be merch?',
    a: 'Yes. Embroidered hoodies in dad-friendly colors (charcoal, oat, navy). XL and up. Drawstrings double-knotted.' },
  { q: "What does 'GG' mean in 'GG Dad'?",
    a: "Officially: 'Good Game.' Unofficially: 'Goodnight, Goodbye' (to the kids). Either reading is correct and we will not be picking one." }
];
